/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { get, post } from '../api/client';
import type {
  SupportAccessGrant,
  RevokeSupportAccessRequest,
  SupportAccessStatsResponse,
} from '@/types/support-access';

interface ApiSuccess<T> {
  success: boolean;
  data: T;
  message?: string;
}

interface PagedData<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
  hasNext: boolean;
  hasPrevious: boolean;
}

const BASE = '/superadmin/support-access';

export const superAdminSupportAccessService = {
  getGrants: async (params: { status?: string; page: number; size: number }): Promise<PagedData<SupportAccessGrant>> => {
    const res = await get<ApiSuccess<PagedData<SupportAccessGrant>>>(`${BASE}/grants`, params);
    return res.data;
  },

  getGrant: async (id: string): Promise<SupportAccessGrant> => {
    const res = await get<ApiSuccess<SupportAccessGrant>>(`${BASE}/grants/${id}`);
    return res.data;
  },

  enterSession: async (id: string): Promise<SupportAccessGrant> => {
    const res = await post<ApiSuccess<SupportAccessGrant>>(`${BASE}/grants/${id}/enter`);
    return res.data;
  },

  exitSession: async (id: string): Promise<void> => {
    await post<ApiSuccess<void>>(`${BASE}/grants/${id}/exit`);
  },

  revokeGrant: async (id: string, request?: RevokeSupportAccessRequest): Promise<SupportAccessGrant> => {
    const res = await post<ApiSuccess<SupportAccessGrant>>(`${BASE}/grants/${id}/revoke`, request || {});
    return res.data;
  },

  getStats: async (): Promise<SupportAccessStatsResponse> => {
    const res = await get<ApiSuccess<SupportAccessStatsResponse>>(`${BASE}/stats`);
    return res.data;
  },
};
